import Image from "next/legacy/image";
import { NextPage } from "next";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import Chests from "sections/christmasPage/Chests";
import Tiers from "sections/christmasPage/Tiers";

import Header from "components/Header";
import Footer from "components/Footer";
import BackgroundAsset from "components/BackgroundAsset";
import CustomLink from "components/CustomLink";

import { EXTERNAL_ROUTES } from "config/routes";

export const GIFT_REQUESTS = 2334 + 86347 + 6293 + 2000; //ETH + Polygon + BSC + 2000

const ChristmasPage: NextPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Header />
      {/*top left*/}
      {!isSmallMobile && (
        <BackgroundAsset
          width={isMobile ? 320 : 470}
          height={134}
          top={117}
          left={-33}
          rotate={-22}
          image={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/lights.gif`}
          zIndex={0}
        />
      )}
      {/*top right*/}
      {!isSmallMobile && (
        <BackgroundAsset
          width={isMobile ? 300 : 421}
          height={134}
          top={90}
          right={7}
          rotate={25}
          image={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/lights.gif`}
          zIndex={0}
        />
      )}
      {/*middle left*/}
      {!isSmallMobile && (
        <BackgroundAsset
          width={451}
          height={134}
          top={1090}
          left={-207}
          rotate={-82}
          image={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/lights.gif`}
          zIndex={0}
        />
      )}
      {/*middle right*/}
      {!isSmallMobile && (
        <BackgroundAsset
          width={451}
          height={134}
          top={1690}
          right={-202}
          rotate={86}
          image={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/lights.gif`}
          zIndex={0}
        />
      )}
      <Box
        sx={{
          pt: { xs: 4, lg: 10 },
          backgroundImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/background.png)`,
          backgroundSize: "100% auto",
        }}
      >
        <Container
          sx={{
            minHeight: "70vh",
            flex: 1,
            position: "relative",
          }}
        >
          <Box
            width="80%"
            height={isMobile ? 250 : 600}
            sx={{ mt: { xs: 5, md: 0 }, mx: "auto" }}
            position="relative"
          >
            <Image
              src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/christmas-header.png`}
              alt="christmas-header"
              layout="fill"
            />
          </Box>
          <Typography
            align="center"
            variant="h2"
            component="h2"
            sx={{
              mt: { xs: -4, md: -10 },
              textShadow: "2px 1px 10px rgba(92, 171, 182, 0.9)",
            }}
          >
            Uniqly Christmas Madness has been ended. During Christmas time, we
            have given over {GIFT_REQUESTS} gifts to our community for free!{" "}
            <br />
            Thank you for being part of this event.
          </Typography>
          <Typography
            variant="h4"
            component="h4"
            mt={7}
            fontWeight={400}
            sx={{ lineHeight: "1.4em" }}
          >
            Your items can be found in the “My Items” section.{" "}
            <b>
              Gifts have been already revealed on December 30th 2021, while
              Chests on January 11th, 2022<sup>*</sup>
            </b>
            . To celebrate the grand opening of the Christmas Gifts, we
            organized a huge{" "}
            <CustomLink href={EXTERNAL_ROUTES.DECENTRALAND} target="_blank">
              Decentraland
            </CustomLink>{" "}
            party with DJ and discussion panels! If you missed it, do not worry.
            There will be more to come!
            <br />
            <br />
            Best wishes and Happy New Year!
          </Typography>
          <Typography variant="h5" component="h5" fontWeight={400} mt={3}>
            * If you are still not able to see what you have received, you need
            to refresh the metadata of an NFT through the Item Page on OpenSea.
            You can find our quick guide on how to do it{" "}
            <CustomLink
              href={`${EXTERNAL_ROUTES.UNIQLY_MEDIUM}christmas-gifts-claiming-guide-eb8ab9761f42`}
              target="_blank"
            >
              here
            </CustomLink>
          </Typography>
          <Tiers />
          <Chests />
        </Container>
        <Box
          width="100%"
          sx={{
            height: {
              xs: 180,
              md: 240,
              lg: 530,
            },
          }}
          position="relative"
          mt={12}
        >
          <Image
            src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/footer.png`}
            alt="christmas footer"
            layout="fill"
          />
        </Box>
      </Box>
      <Footer />
    </>
  );
};
export default ChristmasPage;
